import { PickupArrowIcon, DropoffArrowIcon } from "@app/design-system/icons";
import { cx } from "@app/shared/utils/cx";
import styles from "./StopIcon.module.css";

export type StopIconProps = {
  kind: "pickup" | "dropoff";
  className?: string;
};

/**
 * The small circled arrow used wherever a Pickup or Dropoff is listed as a
 * row (Order Details today; any future Stop list). Deliberately not the
 * map's pin-shaped PickupMarker/DropoffMarker (see Map/markers) — those
 * carry a pointer tail and tenant-branded color for map placement; this is
 * a plain neutral-gray circle, per its own design spec.
 */
export const StopIcon = ({ kind, className }: StopIconProps) => (
  <span className={cx(styles.circle, className)}>
    {kind === "pickup" ? <PickupArrowIcon size={10} /> : <DropoffArrowIcon size={9} />}
  </span>
);
